import type { WorkbookDiagnostic } from "@erp/shared-types";

/** The Diagnostic of a Worksheet whose input is no Source or Worksheet in `ids`. */
export function missingInput(
  itemId: string,
  inputId: string,
  ids: ReadonlySet<string>,
): WorkbookDiagnostic[] {
  return ids.has(inputId)
    ? []
    : [
        {
          code: "missing-input",
          message: "Worksheet input does not exist.",
          location: { part: "item", itemId },
        },
      ];
}
